<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M7.71556 2.18554C7.74186 2.12984 7.78247 2.08294 7.83283 2.05016C7.88318 2.01737 7.94127 2 8.00054 2C8.05981 2 8.1179 2.01737 8.16825 2.05016C8.21861 2.08294 8.25922 2.12984 8.28551 2.18554L9.67139 5.12954C9.76269 5.32331 9.89745 5.49095 10.0641 5.61807C10.2308 5.7452 10.4244 5.82801 10.6283 5.8594L13.7276 6.33507C13.7863 6.34399 13.8415 6.36997 13.8869 6.41007C13.9323 6.45016 13.9661 6.50278 13.9844 6.56196C14.0028 6.62114 14.005 6.68453 13.9907 6.74495C13.9765 6.80537 13.9465 6.86041 13.904 6.90386L11.6626 9.19286C11.5148 9.34393 11.4042 9.53041 11.3403 9.73625C11.2765 9.94209 11.2613 10.1611 11.296 10.3745L11.8252 13.6085C11.8356 13.6701 11.8292 13.7335 11.8069 13.7914C11.7846 13.8494 11.7472 13.8996 11.6989 13.9363C11.6507 13.9731 11.5936 13.9949 11.5341 13.9992C11.4747 14.0035 11.4152 13.9903 11.3626 13.9609L8.59208 12.4332C8.40953 12.3327 8.20643 12.2802 8.00024 12.2802C7.79405 12.2802 7.59094 12.3327 7.40839 12.4332L4.63844 13.9609C4.58585 13.9901 4.52649 14.0032 4.46713 13.9988C4.40777 13.9944 4.35078 13.9726 4.30265 13.9358C4.25452 13.8991 4.21718 13.849 4.19488 13.7911C4.17257 13.7333 4.1662 13.67 4.17648 13.6085L4.70504 10.3751C4.73995 10.1616 4.72482 9.94248 4.66096 9.73651C4.5971 9.53054 4.48642 9.34396 4.33847 9.19286L2.09707 6.90449C2.05423 6.86109 2.02387 6.80595 2.00946 6.74535C1.99504 6.68474 1.99714 6.62111 2.01553 6.5617C2.03391 6.50229 2.06783 6.44948 2.11344 6.4093C2.15904 6.36912 2.21448 6.34318 2.27346 6.33444L5.37218 5.8594C5.57631 5.82825 5.77017 5.74555 5.93707 5.61841C6.10398 5.49127 6.23892 5.3235 6.33029 5.12954L7.71556 2.18554Z"
			:fill="computedFill"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconStar',
	props: {
		size: {
			type: [Number, String],
			default: 16
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.5
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
